<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="Biometria"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  >
    <st-data-display label="Escolha LIO" v-if="hasIntraocularLens">
      <div class="text-pre">
        <strong class="text-gray mr-1">D:</strong>
        <span>{{ data.intraocularLensR || '-' }}</span>
      </div>
      <div class="text-pre">
        <strong class="text-gray mr-1">E:</strong>
        <span>{{ data.intraocularLensL || '-' }}</span>
      </div>
    </st-data-display>
  </eye-exam-card>
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'BiometryView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Ceratometria Média (K)',
            R: 'cornealCurvatureR',
            L: 'cornealCurvatureL',
            formatter: formatters.diopter,
          },
          {
            label: 'Cyl / Eixo',
            R: ['cylinderR', 'axisR'],
            L: ['cylinderL', 'axisL'],
            formatter: this.formatCylinderAxis,
          },
          {
            label: 'AL',
            R: 'axialLengthR',
            L: 'axialLengthL',
            formatter: v => formatters.millimeter(v, 2),
          },
          {
            label: 'ACD',
            R: 'anteriorChamberDepthR',
            L: 'anteriorChamberDepthL',
            formatter: v => formatters.millimeter(v, 2),
          },
          {
            label: 'LT',
            R: 'lensThicknessR',
            L: 'lensThicknessL',
            formatter: v => formatters.millimeter(v, 2),
          },
        ],
      },
    };
  },
  computed: {
    hasIntraocularLens() {
      return this.data.intraocularLensR || this.data.intraocularLensL;
    },
  },
  methods: {
    formatCylinderAxis(cylinder, axis) {
      if (!cylinder && !axis) return '';
      return [formatters.diopter(cylinder), formatters.deg(axis)].filter(v => v !== '').join(' @ ');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
